import {Box, Typography} from "@mui/material";
import {Measure} from "../../services/GreenLoanService";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import BoltIcon from '@mui/icons-material/Bolt';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import {MeasureList} from "../MeasureList";
import React, {useMemo, useState} from "react";

interface Props {
    measures: Measure[]
}

const _groupBy = require('lodash/groupBy');

export function MeasureGroup(props: Props) {
    const groupedMeasures: {
        ENERGY_PRODUCTION: Measure[]
        ISOLATION_AND_FACADE: Measure[]
        TECHNICAL_EQUIPMENT: Measure[]
    } = useMemo(() => _groupBy(props.measures, 'group'), [props.measures])

    const [expandedMeasureNumber, setExpandedMeasureNumber] = useState<number | null>(null)

    return (
        <Box>
            <Typography fontWeight="bold" color="primary" fontFamily="SpareBank1-medium">
                Tiltak
            </Typography>
            <Typography>
                Velg det du skal gjøre eller har gjort med bygningen.
            </Typography>
            {groupedMeasures.ISOLATION_AND_FACADE && <Box>
                <Box sx={{display: "flex", paddingTop: "25px"}}>
                    <HomeOutlinedIcon color="primary" sx={{marginRight: "5px"}}/>
                    <Typography color="primary" fontWeight="bold" fontFamily="SpareBank1-medium">Isolering og
                        fasade</Typography>
                </Box>
                <MeasureList measures={groupedMeasures.ISOLATION_AND_FACADE}
                             expandedMeasureNumber={expandedMeasureNumber}
                             setExpandedMeasureNumber={setExpandedMeasureNumber}
                />
            </Box>}
            {groupedMeasures.TECHNICAL_EQUIPMENT && <Box>
                <Box sx={{display: "flex", paddingTop: "25px"}}>
                    <DeviceThermostatIcon color="primary" sx={{marginRight: "5px"}}/>
                    <Typography color="primary" fontWeight="bold" fontFamily="SpareBank1-medium">Teknisk
                        utstyr</Typography>
                </Box>
                <MeasureList measures={groupedMeasures.TECHNICAL_EQUIPMENT}
                             expandedMeasureNumber={expandedMeasureNumber}
                             setExpandedMeasureNumber={setExpandedMeasureNumber}
                />
            </Box>}
            {groupedMeasures.ENERGY_PRODUCTION && <Box>
                <Box sx={{display: "flex", paddingTop: "25px"}}>
                    <BoltIcon color="primary" sx={{marginRight: "5px"}}/>
                    <Typography color="primary" fontWeight="bold" fontFamily="SpareBank1-medium">Energi</Typography>
                </Box>
                <MeasureList measures={groupedMeasures.ENERGY_PRODUCTION}
                             expandedMeasureNumber={expandedMeasureNumber}
                             setExpandedMeasureNumber={setExpandedMeasureNumber}
                />
            </Box>}
        </Box>
    )
}